import { render, staticRenderFns } from "./ScoutFormPrefecture.vue?vue&type=template&id=139595c4"
import script from "./ScoutFormPrefecture.vue?vue&type=script&lang=js"
export * from "./ScoutFormPrefecture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports